import { userConstants } from "../../constant";

const initialState = {
  subscriptions: [],
  loading: false,
};

export function subscriptions(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.payload.subscriptions || [],
        loading: false,
      };
    case userConstants.CREATE_SUBSCRIPTION:
      return {
        ...state,
        subscriptions: [action.payload.subscription, ...state.subscriptions],
        loading: false,
      };
    case userConstants.UPDATE_SUBSCRIPTION:
      return {
        ...state,
        subscriptions: state.subscriptions.map((sub) =>
          sub.id === action.payload.subscription.id
            ? action.payload.subscription
            : sub
        ),
        loading: false,
      };
    case userConstants.CANCEL_SUBSCRIPTION:
      return {
        ...state,
        subscriptions: state.subscriptions.map((sub) =>
          sub.id === action.payload.id
            ? { ...sub, is_active: false }
            : sub
        ),
        loading: false,
      };
    default:
      return state;
  }
}
